<template>
  <div>
    <footer id="contact-us">
      <div class="container">
        <div class="row">
          <div class="sub-footer col-lg-12 col-md-12 col-sm-12">
            <div class="col-lg-6">
              <p>Copyright &copy; The Edge Communications Sdn. Bhd.</p>
            </div>

            <div class="col-lg-6 followus">
              <p>Follow Us</p>

              <ul class="social">
                <li>
                  <a
                    href="https://www.facebook.com/theedgemalaysia"
                    target="_blank"
                    ><i class="fa fa-facebook"></i
                  ></a>
                </li>
                <li>
                  <a href="https://twitter.com/theedgemalaysia" target="_blank"
                    ><i class="fa fa-twitter"></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/the-edge-communications"
                    target="_blank"
                    ><i class="fa fa-linkedin" target="_blank"></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/esgtheedge/"
                    target="_blank"
                    ><i class="fa fa-instagram"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
